import { MdAssignment as SummaryIcon } from 'react-icons/md';

export default SummaryIcon;
